import { useClientReportHeaderSectionQuery } from 'generated/graphql';
import _ from 'lodash';
import React from 'react';

export interface IData {
  id: string;
  isApproved: boolean;
}

export function useQuery(id: string) {
  const tuple = useClientReportHeaderSectionQuery({
    variables: {
      id
    },
    skip: id === ''
  });

  return React.useMemo(
    () => {
      const data: IData = {
        id: tuple.data?.clientReport?.id ?? '',
        isApproved: !_.isNull(tuple.data?.clientReport?.approvedAt)
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
